import React from 'react';
import { PdfFieldEntity } from '../data/PdfDataKey';
import { PdfFieldResolving } from '../data/PdfFieldResolving';
import { PdfBorderStyle, PdfFieldComponent, PdfTextAlign, PdfVerticalAlign } from '../PdfComponent';
import { usePdfTemplateContext } from '../PdfTemplateEditorContext';

export default function PdfTemplateFieldPreview<T>({ component }: { component: PdfFieldComponent }) {
  const { dataKeys: fieldProviders, fontToCss, selectedEntity, documentProperties, data } = usePdfTemplateContext<T>();

  const borderStyle = (() => {
    switch (component.border.style) {
      case PdfBorderStyle.dashed:
        return 'dashed';
      case PdfBorderStyle.dotted:
        return 'dotted';
      default:
        return 'solid';
    }
  })();

  const justifyContent = (() => {
    switch (component.align) {
      case PdfTextAlign.center:
        return 'center';
      case PdfTextAlign.right:
        return 'flex-end';
      default:
        return 'flex-start';
    }
  })();

  const alignItems = (() => {
    switch (component.valign) {
      case PdfVerticalAlign.middle:
        return 'center';
      case PdfVerticalAlign.bottom:
        return 'flex-end';
      default:
        return 'flex-start';
    }
  })();

  let text = !component.key
    ? ''
    : selectedEntity
    ? PdfFieldResolving.getValue(selectedEntity, PdfFieldEntity.order, component.key, data)
    : PdfFieldResolving.getLabel(component.key, data);
  if (component.format) {
    text = component.format.replace('{VALUE}', text);
  }

  return (
    <div
      className={`flex h-full w-full`}
      style={{
        ...fontToCss(component.font || documentProperties.font),
        borderWidth: component.border.enabled ? component.border.width : 0,
        borderColor: component.border.color,
        borderStyle,
        justifyContent: justifyContent,
        alignItems: alignItems,
      }}
    >
      <span>{text}</span>
    </div>
  );
}
